/* 평가항목 행의 「평가제」 select에서 고를 수 있는 값.
수업 단위 평가제(CreateUpdateLessonModal)는 서술형 등을 그대로 고르므로 여기 필터를 쓰지 않는다. */

export const NON_ITEM_EVAL_TYPES = ["평가항목별", "서술형", "커스텀"];

export function getSelectableItemTypes(lessonSetting) {
  const detailedSetting = lessonSetting?.find(
    (item) => item.item_code === "evalMethod",
  )?.detailed_setting;

  if (!Array.isArray(detailedSetting)) return [];

  return detailedSetting.filter(
    (type) => !NON_ITEM_EVAL_TYPES.includes(type),
  );
}
